import api from '@services/api';

import { PaginationResponse } from '../models/pagination';
import {
  CreateProjectBranchConfig,
  ProjectBranchConfigRequest,
  ProjectBranchConfigResponse,
  UpdateProjectBranchConfig,
} from '../models/projectBranchConfig';

/**
 * <p>
 * API endpoints that cover all project branch configs related CRUD calls
 */
export const projectBranchConfigApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    listProjectBranchConfigs: builder.query<
      PaginationResponse<ProjectBranchConfigResponse>,
      ProjectBranchConfigRequest
    >({
      query: (request: ProjectBranchConfigRequest) => ({
        url: encodeURI(
          `/school/project-branch-config/search?${
            request.searchTerm ? `searchTerm=${request.searchTerm}&` : ''
          }periodDate=${request.periodDate}&page=${request.page}&size=${request.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['ProjectBranchConfig'],
    }),
    // POST
    createProjectBranchConfig: builder.mutation<
      ProjectBranchConfigResponse,
      CreateProjectBranchConfig
    >({
      query: (input: CreateProjectBranchConfig) => ({
        url: encodeURI('/school/project-branch-config/create'),
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['ProjectBranchConfig'],
    }),
    // Update
    updateProjectBranchConfig: builder.mutation<
      ProjectBranchConfigResponse,
      UpdateProjectBranchConfig
    >({
      query: (input: UpdateProjectBranchConfig) => ({
        url: encodeURI('/school/project-branch-config/update'),
        method: 'PUT',
        body: input,
      }),
      invalidatesTags: ['ProjectBranchConfig'],
    }),
    // Delete
    deleteProjectBranchConfig: builder.mutation<void, number>({
      query: (id: number) => ({
        url: `/school/project-branch-config/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProjectBranchConfig'],
    }),
  }),
});

export const {
  useListProjectBranchConfigsQuery,
  useCreateProjectBranchConfigMutation,
  useUpdateProjectBranchConfigMutation,
  useDeleteProjectBranchConfigMutation,
} = projectBranchConfigApi;
